import { QuestionnaireQuestionType } from 'src/containers/QuestionnaireParent/QuestionnaireEnum';
import {
  deepClone,
  handleQuestionRender,
  stringToObject,
} from 'src/legacy/utils/helpers';

export const evaluateSubmitButtonStatus = (
  currentQuestions: Array<any>,
  currentPage: any,
): boolean => {
  const questions = deepClone(currentQuestions);
  const pageMetadata =
    currentPage?.metadata && stringToObject(currentPage?.metadata);

  const isPageOptional = pageMetadata?.isOptional === 'true' || false;

  // only consider questions which are visible
  const visibleQuestions = questions.filter((question: any) =>
    handleQuestionRender(question, questions),
  );

  if (isPageOptional) {
    return true;
  }

  for (const question of visibleQuestions) {
    const isQuestionRequired = question.required || false;
    const questionType = question?.metadata?.question_type;

    if (isQuestionRequired) {
      let isQuestionAnswered = false;

      for (const choice of question.choices) {
        // Handle slider questions specially for 0 value.
        const isSlider =
          questionType === QuestionnaireQuestionType.CUSTOM_SLIDER;
        const isFileType = questionType === QuestionnaireQuestionType.FILE;
        const isDropdown = questionType === QuestionnaireQuestionType.DROPDOWN;
        const isRadio = questionType === QuestionnaireQuestionType.RADIO;

        if (isFileType) {
          if (choice.value && choice.value.trim().length > 0) {
            isQuestionAnswered = true;
          }
        } else if (isDropdown || isRadio) {
          if (choice.selected) {
            isQuestionAnswered = true;
          }
        } else {
          const hasValue = isSlider
            ? choice.value !== null && choice.value !== undefined
            : choice.selected || choice.value;

          if (hasValue) {
            isQuestionAnswered = true;

            const hasOther = choice.metadata?.has_other || false;

            if (hasOther && !choice.value?.trim()) {
              return false; // 'Other' is selected but the value is empty
            }

            if (choice.nodes) {
              for (const subChoice of choice.nodes) {
                if (
                  subChoice.metadata?.has_other &&
                  subChoice.selected &&
                  !subChoice.value?.trim()
                ) {
                  return false; // Nested 'Other' is selected but the value is empty
                }
              }
            }
          }
        }
      }

      if (!isQuestionAnswered) {
        return false; // Required question is not answered
      }
    }

    if (isQuestionRequired) {
      for (const choice of question.choices) {
        if (choice.isValid === false) {
          return false; // A choice is invalid
        }

        if (choice.required) {
          const isFileType = questionType === QuestionnaireQuestionType.FILE;
          const isDropdown =
            questionType === QuestionnaireQuestionType.DROPDOWN;
          const isRadio = questionType === QuestionnaireQuestionType.RADIO;

          if (isFileType) {
            if (!choice.value || !choice.value.trim()) {
              return false;
            }
          } else if (isDropdown || isRadio) {
            if (!choice.selected) {
              return false;
            }
          } else {
            if (!choice.value || !choice.value.trim()) {
              return false;
            }
          }
        }
      }
    }
  }

  return true; // All required questions are answered and valid
};
